import { useLocation, useNavigate } from 'react-router-dom';
import { LogIn, X } from 'lucide-react';

/**
 * Shown when a guest tries to join an activity — same chrome as FaceVerificationModal.
 */
const JoinLoginPromptModal = ({ open, onClose, activityId }) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center p-4">
      <button
        type="button"
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        aria-label="Close"
        onClick={onClose}
      />
      <div className="relative w-full max-w-md rounded-2xl border border-surface-200 bg-white p-6 shadow-2xl dark:border-surface-700 dark:bg-surface-900">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-3 rounded-lg p-1.5 text-surface-400 hover:bg-surface-100 dark:hover:bg-surface-800"
          aria-label="Close"
        >
          <X size={18} />
        </button>
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-500 to-violet-600 shadow-lg shadow-brand-500/25">
          <LogIn size={28} className="text-white" strokeWidth={2.25} />
        </div>
        <h3 className="text-center text-lg font-extrabold text-surface-900 dark:text-white">Join the Vibe</h3>
        <p className="mt-2 text-center text-sm leading-relaxed text-surface-600 dark:text-surface-400">
          Log in or sign up to join vibes and connect with others.
        </p>
        <div className="mt-6 flex flex-col gap-2 sm:flex-row sm:justify-center">
          <button
            type="button"
            onClick={() => {
              onClose?.();
              navigate('/login', {
                state: { from: location, pendingJoinActivityId: activityId || null },
              });
            }}
            className="rounded-xl bg-gradient-to-r from-brand-500 to-violet-600 px-5 py-3 text-sm font-bold text-white shadow-md shadow-brand-500/20 transition hover:brightness-110"
          >
            Log in
          </button>
          <button
            type="button"
            onClick={() => {
              onClose?.();
              navigate('/register', {
                state: { from: location, pendingJoinActivityId: activityId || null },
              });
            }}
            className="rounded-xl border border-surface-200 px-5 py-3 text-sm font-semibold text-surface-600 transition hover:bg-surface-50 dark:border-surface-600 dark:text-surface-300 dark:hover:bg-surface-800"
          >
            Create account
          </button>
        </div>
      </div>
    </div>
  );
};

export default JoinLoginPromptModal;
